var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:(_vm.style),attrs:{"src":require(`@/assets/lang-${_vm.code}.png`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }